import {
  HOTEL_DISCOUNT_RATE_TYPES,
  HOTEL_GREAT_SAVING_RATE_TYPES,
  HOTEL_HIDDEN_RATE_TYPES,
  HOTEL_RATE_TYPES,
  HOTEL_SAVE_RATE_TYPES,
} from '@web-platform/shared-universal-constants/src/hotelsCrossSell';

import { translate } from '../translate';

import type { HotelRateType } from '@web-platform/shared-universal-types/src/components/hotelsCrossSell';

export const getHotelCugTranslation = (percentage?: number, type?: HotelRateType) => {
  if (!type) {
    return undefined;
  }

  if (!percentage && HOTEL_GREAT_SAVING_RATE_TYPES.includes(type)) {
    return translate('ktxt_hotels_cross_sell_badge_great_saving');
  }

  if (!percentage && HOTEL_HIDDEN_RATE_TYPES.includes(type)) {
    return undefined;
  }

  if (type === HOTEL_RATE_TYPES.mobile) {
    return translate('ktxt_hotels_cross_sell_badge_mobile_only');
  }

  if (type === HOTEL_RATE_TYPES.loggedIn) {
    return translate('ktxt_hotels_cross_sell_badge_logged_in');
  }

  return undefined;
};

export const getHotelCugPercentageTranslation = (
  type: HotelRateType | undefined,
  percentage?: number | undefined,
) => {
  if (!type) {
    return undefined;
  }

  if (HOTEL_DISCOUNT_RATE_TYPES.includes(type)) {
    return translate('ktxt_hotels_cross_sell_badge_discount_percentage').replace(
      '{0}',
      String(percentage),
    );
  }

  if (HOTEL_SAVE_RATE_TYPES.includes(type)) {
    return translate('ktxt_hotels_cross_sell_badge_save_percentage', {
      pct_saving: percentage,
    });
  }

  return undefined;
};
